import { render, staticRenderFns } from "./RatingsHelp.vue?vue&type=template&id=d06f9a60"
import script from "./RatingsHelp.vue?vue&type=script&lang=js"
export * from "./RatingsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports